import { Card, CardProps } from "antd";
import { forwardRef } from "react";
import styled from "styled-components";

const StyledHoverableCard = styled(Card)<
  CardProps & { $borderColor?: string; $opacity: number }
>`
  opacity: ${({ $opacity }) => $opacity};
  transition: opacity 0.5s ease;

  .hoverable-button-text {
    opacity: 0;
    transition: opacity 0.5s ease-in-out;
  }

  &.ant-card-hoverable:hover {
    border-color: ${({ theme, $borderColor }) =>
      $borderColor ?? theme.colorPrimary};
    box-shadow: none;
    opacity: ${({ $opacity }) => $opacity + 0.2};

    .hoverable-button-text {
      opacity: 1;
    }
  }
`;

export const HoverableCard = forwardRef<
  HTMLDivElement,
  {
    borderColor?: string;
    opacity?: number;
  } & CardProps
>(({ borderColor, children, opacity = 1, ...props }, ref) => {
  return (
    <StyledHoverableCard
      ref={ref}
      {...props}
      $borderColor={borderColor}
      $opacity={opacity}
    >
      {children}
    </StyledHoverableCard>
  );
});

HoverableCard.displayName = "HoverableCard";
